// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-8da29132] .el-dialog--center .el-dialog__body{flex:1;height:0;overflow-y:scroll}", ""]);
// Exports
module.exports = exports;
